module.exports = __webpack_public_path__ + "img/individual_name.b7d6ef1b.svg";